import React, { Component } from 'react'
import Color from 'color'
import { withRouter } from 'react-router-dom'
import { injectStripe, CardElement } from 'react-stripe-elements'
import { flexUtils, palette } from '../../../Theme/Theme'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import * as Actions from '../../../Actions/Actions'

class ChangeCardForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    render() {
        const { classes } = this.props
        const { Container, CardEntry, CancelButton, SubmitButton } = classes
        return (
            <div className={Container}>
                <div className={CardEntry}>
                    <CardElement style={cardStyle}/>
                </div>
                <button className={CancelButton} onClick={this.props.onCancel}>Cancel</button>
                <button className={SubmitButton} onClick={this.onSubmit}>{this.state.loading ? <i className="fas fa-spinner fa-spin"/> : 'Submit'}</button>
            </div>
        )
    }

    onCancel = () => {
        this.props.history.push('/Home/AccountInfo')
    }

    onSubmit = e => {
        const { user, dispatch, history } = this.props
        e.preventDefault()
        this.setState({ loading: true })
        if (this.props.stripe) {
            this.props.stripe
            .createToken()
            .then(token => {
                const data = {
                    payments: {
                        platform: 'stripe',
                        stripeToken: token.token.id
                    }
                }
                // console.log(token)
                dispatch(Actions.updateUser(user.token, data, history))
            })
        } else {
            console.log("Stripe.js hasn't loaded yet.")
        }
    }
}

const cardStyle = {
    base: {
        fontSize: '24px',
        color: palette.white
    }
}

const styles = {
    ...flexUtils,
    Container: {
        composes: ['$FlexColumn', '$FlexCenter'],
        padding: '7rem 1rem'
    },
    CardEntry: {
        background: 'rgba(255, 255, 255, 0.1)',
        width: '100%',
        padding: '1rem',
        borderRadius: '5px'
    },
    ButtonContainer: {
        composes: ['$FlexRow', '$FlexCenter']
    },
    Button: {
        border: 'none',
        width: '100%',
        height: '3rem',
        fontSize: '20px',
        color: palette.white,
        marginTop: '1rem',
        borderRadius: '3px',
        transition: 'all .5s',
        '&:focus': {
            outline: 'none'
        }
    },
    SubmitButton: {
        composes: '$Button',
        background: palette.blue,
        '&:hover': {
            background: `${Color(palette.blue).darken(0.2)}`
        }
    },
    CancelButton: {
        composes: '$Button',
        color: 'rgb(60, 60, 60)'
    }
}

const mapStateToProps = state => {
    return {
        user: state.mainState.user
    }
}

export default withRouter(connect(mapStateToProps)(injectStripe(injectSheet(styles)(ChangeCardForm))))


// WEBPACK FOOTER //
// ./src/js/Components/Home/Settings/ChangeCardForm.jsx